import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

const PRIVATE_CDN_PREFIX = "https://static.puntt.ai/";

function isPrivateCdnUrl(url: string): boolean {
  return (
    url.startsWith(PRIVATE_CDN_PREFIX) &&
    !url.startsWith(`${PRIVATE_CDN_PREFIX}public/`)
  );
}

/**
 * Exchange a private static.puntt.ai URL for a short-lived presigned S3 GET
 * URL that pdf.js can fetch without needing the service-worker auth injection.
 *
 * Returns the original URL unchanged for public paths or non-CDN URLs so the
 * caller can always use the return value unconditionally.
 */
export async function getSignedPdfUrl(url: string): Promise<string> {
  if (!isPrivateCdnUrl(url)) {
    return url;
  }
  try {
    const result = (await smartFetch(
      `${API_URL}/private/catalyst/files/signed-url?url=${encodeURIComponent(url)}`,
    )) as { url?: string } | null;
    if (result?.url) {
      return result.url;
    }
  } catch (err) {
    console.error("[getSignedPdfUrl] failed to obtain presigned URL", err);
  }
  return url;
}
